// extracted by mini-css-extract-plugin
export var md = "_4n-4";
export var semantic = "_4n-5";
export var sm = "_4n-3";
export var text = "_4n-6";
export var toggleInput = "_4n-0";
export var toggleSwitch = "_4n-1";
export var xs = "_4n-2";